import { PurchaseWizard } from 'src/modals/PurchaseWizard';
import { TicketGroupEditContext } from 'src/modals/PurchaseWizard/PurchaseWizard.types';
import { PurchaseDeeplinkQueryParam } from 'src/utils/constants/constants';

export const PurchaseWizardModalConfig = (
  deepLinkValue?: number | string,
  seedTicketGroupEditContext?: Partial<TicketGroupEditContext>,
  forceNewPurchaseOrder?: boolean
) => ({
  children: (
    <PurchaseWizard
      deepLinkValue={deepLinkValue}
      seedTicketGroupEditContext={seedTicketGroupEditContext}
      forceNewPurchaseOrder={forceNewPurchaseOrder}
    />
  ),
  clickOutsideToClose: true,
  deepLinkKey: PurchaseDeeplinkQueryParam,
  deepLinkValue: deepLinkValue,
  size: 'slide-in',
});
